import React from "react";
import AwardsWithAptechSection from "../components/AwardsWithAptech/AwardsWithAptech.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const AwardWithAptech = () => {
  return (
    <div>
       <MetaComponent
        title="Aptech’s Awards & Achievements | Leading Vocational Training Provider"
        desc="Explore Aptech's global awards and achievements, highlighting its excellence in vocational training across IT, animation, beauty and wellness, aviation, and hospitality industries."
        keywords="aptech awards, vocation training provider, aptech global achievements"
      />
      <AwardsWithAptechSection />
    </div>
  );
};

export default AwardWithAptech;
